import React,{useState,useEffect} from 'react'
import ArticleViewer from './subcomponents/ArticleViewer'
import { createTheme } from '@mui/material/styles';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Box,Paper, Typography, Button,Slide,IconButton,Stack,Avatar,Chip,Divider } from "@mui/material";
import TopHeader from './subcomponents/TopHeader';
import BottomFooter from './subcomponents/BottomFooter';
import {
    Facebook,
    Twitter,
    LinkedIn,
    Print
  } from "@mui/icons-material";
const theme = createTheme({
    palette: {
      primary: {
        main: '#1976d2', // Customize your primary color
      },
      secondary: {
        main: '#9c27b0',
      },
      background: {
        default: '#f9f9f9',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    shape: {
      borderRadius: 16,
    },
    spacing: 8, // Default spacing multiplier
  });
function Articles() {
    const handlePrint = () => window.print();
    const articleTitle = "Article Title Might be long";
  const shareUrl = window.location.href;
     const [clinicData, setClinicData] = useState({
          clinicName: "Delta Eye Clinic",
          primaryColor: "#E3F2FD",
          secondaryColor: "#00796B",
          logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
          address: "123 Main Street, Cityville, ST 12345",
          phone: "(123) 456-7890",
          fax: "(123) 456-7899",
          backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
        });
    const content = JSON.stringify({
        html: '<h2>Hello World</h2><p>This content came from Jodit!</p>',
      });
  return (
   <>
    <Box
      sx={{
       
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 3,
      }}
    >
    {clinicData && <TopHeader clinicData={clinicData} />}
 {/* Form Section */}
              <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                 <Paper
                    elevation={4}
                    sx={{
                        padding: 4,
                        maxWidth: "lg",
                        width: "100%",
                        borderRadius: 3,
                        textAlign: "left",
                        backgroundColor: "#fff",
                        minHeight:"70vh",
                        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                        marginTop: { xs: 5, md: 14 },
                    }}
                    >
                        <Typography variant="h4"  sx={{ fontWeight: "bold", color: clinicData.secondaryColor }}>
                            Article Title Might be long
                        </Typography>
                        <Typography variant="subtitle2"  sx={{ mb: 3, fontWeight: "bold", color: clinicData.secondaryColor }}>
                            Article Description
                        </Typography>
                        <Divider sx={{ my: 2 }} />
                       
                      {/* Tags + Share + Print */}
                        <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={2}
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        justifyContent="space-between"
                        flexWrap="wrap"
                        mb={3}
                        >
                        {/* Tags */}
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <Chip label="Health" color="primary" variant="outlined" />
                            <Chip label="Wellness" color="primary" variant="outlined" />
                        </Stack>

                        {/* Social & Print */}
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                            sx={{ mt: { xs: 2, sm: 0 }, flexWrap: "wrap" }}
                        >
                            <Typography variant="caption" sx={{ fontWeight: "bold", mr: 1 }}>
                            Share:
                            </Typography>
                            <IconButton
                            component="a"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                            target="_blank"
                            rel="noopener"
                            aria-label="Share on Facebook"
                            >
                            <Facebook fontSize="small" />
                            </IconButton>
                            <IconButton
                            component="a"
                            href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${articleTitle}`}
                            target="_blank"
                            rel="noopener"
                            aria-label="Share on Twitter"
                            >
                            <Twitter fontSize="small" />
                            </IconButton>
                            <IconButton
                            component="a"
                            href={`https://www.linkedin.com/shareArticle?url=${shareUrl}&title=${articleTitle}`}
                            target="_blank"
                            rel="noopener"
                            aria-label="Share on LinkedIn"
                            >
                            <LinkedIn fontSize="small" />
                            </IconButton>
                            <IconButton onClick={handlePrint} aria-label="Print Article">
                            <Print fontSize="small" />
                            </IconButton>
                        </Stack>
                        </Stack>

                        <ThemeProvider theme={theme}>
                            <CssBaseline />
                            {/* Article Content fetched using api.  */}
                            <ArticleViewer contentJson={content} theme={theme} />
                        </ThemeProvider>
                   </Paper>
                </Slide>
  {clinicData && <BottomFooter clinicData={clinicData} />}
  </Box>
   </>
  )
}

export default Articles